import 'reflect-metadata';
import { Vue, Component, Watch } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';

import store from '@/store/store';

import MarcacaoUtils from '@/assets/ts/utils/MarcacaoUtils';

import Time from '@/../bower_components/teknisavuecomponents/assets/utils/Time';
import Http from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import FormatacaoHora from '@/../bower_components/teknisavuecomponents/assets/utils/FormatacaoHora';
import { User, Periodo } from '@/../bower_components/teknisavuecomponents/assets/interfaces/interfaces';
import DialogUtils from '@/../bower_components/teknisavuecomponents/assets/utils/DialogUtils';

import InlineGrid from '@/../bower_components/teknisavuecomponents/components/grids/inline-grid/InlineGrid.vue';
import OcorDialog from '@/components/demonstrativo/OcorDialog/OcorDialog.vue';
import TkSelect from '@/../bower_components/teknisavuecomponents/components/fields/TkSelect.vue';
import MarcacoesPopup from '@/components/demonstrativo/MarcacoesPopup/MarcacoesPopup.vue';
import OcorrenciasPopup from '@/components/demonstrativo/OcorrenciasPopup/OcorrenciasPopup.vue';
import SituFreqPopup from '@/components/demonstrativo/SituFreqPopup/SituFreqPopup.vue';
import AlertasApuracao from '@/components/AlertasApuracao/AlertasApuracao.vue';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import FileUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FileUtils';
import Messages from '@/assets/ts/utils/Messages';
import DemonstrativoController from '@/assets/ts/controller/DemonstrativoController';
import ApuracaoController, { Vinculo as ApuracaoVinculo } from '@/assets/ts/controller/ApuracaoController';
import NovaOcorrenciaPopup from '@/components/ocorrencia/NovaOcorrenciaPopup/NovaOcorrenciaPopup.vue';
import ApuraAutoAdcNoturnoPopup from '@/components/demonstrativo/ApuraAutoAdcNoturnoPopup/ApuraAutoAdcNoturnoPopup.vue';
import { ActionPermissao, ControleAcessoController, ControleAcessoWrapper, ModuloPermissao } from '@/assets/ts/controller/ControleAcessoController';

@Component({
  name: 'Demonstrativo',
  components: {
    InlineGrid,
    TkSelect,
    MarcacoesPopup,
    OcorrenciasPopup,
    OcorDialog,
    SituFreqPopup,
    AlertasApuracao,
    NovaOcorrenciaPopup,
    ApuraAutoAdcNoturnoPopup,
  },
})
class Demonstrativo extends Vue {
  // #region [ DATA ]
  private toolbarShowDefaultActions = true;

  private readonly ROW_FERIADO_IDENTIFIER   = 'OCORRENCIA_FERIADO';

  private toolbarNotShowWichDefaultActions = [
    'baixar',
    'imprimir',
    'alinhar',
  ];

  private toolbarDefaultActionsOnClick = {
    refresh: () => this.reloadData(),
  };

  private toolbarCadAutoActionName = 'cadAutoMarc';

  private toolbarApurarActionName = 'apurar';
  private toolbarApurarTodosActionName = 'apurarPeriodoVinculoTodos';

  private toolbarRetrocederActionName = 'retroceder';
  private toolbarRetrocederTodosActionName = 'retrocederPeriodoVinculoTodos';

  private toolbarSalvarActionName = 'salvar';
  private toolbarCancelarActionName = 'cancelar';

  private actionsToShowWithNoFilters = [
    this.toolbarApurarActionName,
    this.toolbarRetrocederActionName,
  ];

  private actionsNotToShowWhenBloqueioEdicao = [
    this.toolbarSalvarActionName,
    this.toolbarCancelarActionName,
  ];

  private toolbarAdditionalActions = [
    {
      name: this.toolbarApurarActionName,
      icon: 'mdi-location-enter',
      label: 'Apurar',
      showLabel: true,
      disabled: true,
      menu: true,
      items: [
        {
          name: 'apurarPeriodoVinculoAtual',
          label: 'Apurar Vínculo Selecionado',
          customShowOnlyWithFilters: true,
          onClick: ControleAcessoWrapper.criar(this.apurarPeriodoOnClick),
        },
        {
          name: this.toolbarApurarTodosActionName,
          label: this.actionApurarTodosLabel,
          onClick: ControleAcessoWrapper.criar(this.apurarPeriodoTodosOnClick),
        },
      ]
    },
    {
      name: this.toolbarRetrocederActionName,
      icon: 'cancel',
      label: 'Retroceder',
      showLabel: true,
      disabled: true,
      items: [
        {
          name: 'retrocederPeriodoVinculoAtual',
          label: 'Retroceder Vínculo Selecionado',
          customShowOnlyWithFilters: true,
          onClick: ControleAcessoWrapper.atualizar(this.retrocederPeriodoOnClick),
        },
        {
          name: this.toolbarRetrocederTodosActionName,
          label: this.actionRetrocederTodosLabel,
          onClick: ControleAcessoWrapper.atualizar(this.retrocederPeriodoTodosOnClick),
        },
      ]
    },
    {
      name: this.toolbarSalvarActionName,
      icon: 'save',
      label: 'Salvar',
      showLabel: true,
      disabled: true,
      returnEditedRows: true,
      onClick: this.salvarMarcacoesGrid,
    },
    {
      name: this.toolbarCancelarActionName,
      icon: 'undo',
      label: 'Cancelar',
      showLabel: true,
      disabled: true,
      // Criar logica pro disabled ficar disponivel só quando tiver mudanças
      onClick: () => this.triggers.cancelGrid++,
    },
  ];

  private toolbarButtons = [];

  private inlineGridKey = Math.random();

  private viewName = 'Demonstrativo';

  private viewTitle = 'Demonstrativo';

  // private nrVinculo = -1;
  private vinculo: Vinculo = null;

  private showMarcacoesPopup = false;
  private showOcorrenciasPopup = false;

  private situFreqPopup = {
    show: false,
    nrVinculo: null as number,
    date: null as string,
  };

  private alertasApuracao = {
    show: false,
  };

  private apuraAutoAdcNoturno = {
    show: false,
    nrVinculo: null as number,
    rows: [],
    dtiniperiodo: null as string,
    dtfimperiodo: null as string,
    nrPeriodo: null as number,
    vinculosUnidade: [],
    nomeUnidade: null as string,
  }

  private novaOcorrencia = {
    show: false,
    nrVinculo: null,
    rows: [],
  };

  private windowLastHeight = window.innerHeight;

  private snack = false;

  private dataBackup = null;

  private motivosOcorrencia = [];

  private selectedDate = '';
  private selectedDates = [];

  private triggers = {
    reloadVinculoSelect: 0,
    reloadGrid: 0,
    cancelGrid: 0,
    saveGrid: 0,
    reloadOcorrencias: 0,
    reloadMarcacoes: 0,
  };

  private gridCols = [
    {
      text: 'Dia',
      value: 'DTAPURACAO',
      type: 'text',
      align: 'left',
      readOnly: true,
      width: 120,
      style: this.getDiaColStyle,
    },
    {
      text: 'Horário',
      value: 'DSTIPOHORARIO',
      type: 'text',
      align: 'center',
    },
    {
      text: '',
      value: 'STATUSMARC',
      align: 'center',
      readOnly: true,
      cssClass: this.getMarcStyle,
      tooltip: 'Existem possíveis pendências para o dia',
      width: 60,
    },
    {
      text: 'Entrada',
      value: 'ENTRADA',
      type: 'time',
      align: 'center',
    },
    {
      text: 'Intervalo',
      value: 'ALMOCO',
      type: 'time',
      align: 'center',
    },
    {
      text: 'Saída',
      value: 'SAIDA',
      type: 'time',
      align: 'center',
    },
    {
      text: 'Ausência',
      value: 'HRAUSENCIA',
      type: 'time',
      align: 'center',
      readOnly: true,
    },
    {
      text: 'Horas Trabalhadas',
      value: 'TRABALH',
      type: 'time',
      align: 'center',
      readOnly: true,
    },
    {
      text: 'Faltas',
      value: 'FL_DIAS',
      type: 'time',
      align: 'center',
      readOnly: true,
    },
    {
      text: 'Diferença',
      value: 'DIF_TRA',
      type: 'time',
      align: 'center',
      readOnly: true,
      style: this.getDiferencaStyle,
    },
    {
      text: 'Banco de Horas',
      value: 'BH_C_AC',
      type: 'time',
      align: 'center',
      readOnly: true,
      style: this.getBancoHorasStyle,
    },
    {
      text: 'Horas Extras',
      value: 'HE_AUTO',
      type: 'time',
      align: 'center',
      readOnly: true,
    },
    {
      text: 'Perda DSR?',
      value: 'IDDSRDESCONTADO',
      type: 'text',
      align: 'select',
      readOnly: true,
      descriptionField: 'DSDSRDESCONTADO',
      valueField: 'IDDSRDESCONTADO',
      items: [
        {
          IDDSRDESCONTADO: 'S',
          DSDSRDESCONTADO: 'Sim',
        },
        {
          IDDSRDESCONTADO: 'N',
          DSDSRDESCONTADO: 'Não',
        },
      ],
    },
    {
      text: 'Observação',
      value: 'DSMOTIVOOCORFREQ',
      type: 'select',
      align: 'center',
      readOnly: true,
      valueField: 'NRMOTIVOOCORFREQ',
      options: this.motivosOcorrencia,
      style: this.getObservacaoStyle,
    },
    {
      text: 'Ações',
      value: 'actions',
      align: 'center',
      readOnly: true,
      width: 175,
    },
  ];

  private gridRows = [];

  private isEditing = false;

  private currentRow = {};

  private gridHeight = 50;

  private customActions = [
    {
      icon: 'mdi-clock',
      label: 'Marcações',
      action: (row: any) => {
        this.openMarcacoesPopup(row);
      },
    },
    {
      icon: 'mdi-message-text-outline',
      label: 'Ocorrências',
      action: (row: any) => {
        this.openOcorrenciasPopup(row);
      },
    },
    {
      icon: 'mdi-puzzle',
      label: 'Situação de Frequência',
      action: this.openSituFreqPopup,
    },
    {
      icon: 'mdi-folder-download',
      label: 'Baixar Fotos das Marcações',
      action: (row: any) => {
        this.downloadMarcacoesFotos(row);
      },
    },
  ];

  private marcacoesPopupData = {
    vinculo: undefined,
    date: undefined,
  };

  private vinculos = [];

  private messages = {
    error: {
      apuracao: 'Houve um erro ao apurar o período.',
    },
  };

  // Grid v-model
  private gridSelected = [];

  private emptyColumnValue = '-';

  private toolbarButtonsDisabled = false;

  private ocorPopupControl = {
    showOcorDialog: false,
    overrideSaveAction: this.solicitarAbonoFalta,
    ocorrenciaFieldsDisplayed: [
      'CDDIAGNOST',
      'NRPESSOA',
      'DSOBSERVACAO',
      'FILE',
    ],
  };

  private trocaHorarioPopupControl = {
    showOcorDialog: false,
    overrideSaveAction: this.trocarHorario,
    defaultRow: {
      NRTIPOPROGOCORRENCIA: '29',
    },
    title: {
      text: 'Troca de Horários',
    },
    ocorrenciaFieldsDisplayed: [
      'NRHORDIAM',
      'NRTIPOPROGOCORRENCIA',
      'DSOBSERVACAO',
      'FILE',
    ],
  };

  private horasExtrasNoBancoDeHorasPopupControl = {
    showOcorDialog: false,
    overrideSaveAction: this.horasExtrasNoBancoDeHoras,
    defaultRow: {
      TIPOSPROGOCORRENCIATEXT: 'Autorizar horas a folgar | Compensar atraso / saída'
    },
    title: {
      text: 'Incluir horas extras como banco de horas',
    },
    ocorrenciaFieldsDisplayed: [
      'TIPOSPROGOCORRENCIATEXT',
      'NRMOTIVOOCORFREQ',
      'DSOBSERVACAO',
      'FILE',
    ],
  };

  private bancoDeHorasNasHorasExtrasPopupControl = {
    showOcorDialog: false,
    overrideSaveAction: this.bancoDeHorasNasHorasExtras,
    defaultRow: {
      NRTIPOPROGOCORRENCIA: '3',
    },
    title: {
      text: 'Incluir horas de banco como hora extras',
    },
    ocorrenciaFieldsDisplayed: [
      'NRTIPOPROGOCORRENCIA',
      'NRMOTIVOOCORFREQ',
      'QTHORAS',
      'DSOBSERVACAO',
      'FILE',
    ],
  };

  private solicitacaoHorasExtras: any = {
    show: false,

    // Fila de datas a serem mostradas em sequencia
    datas: [],

    // Data atual a ser mostrada
    data: '',
    ocorrenciaFieldsDisplayed: ['DSOBSERVACAO'],
    wasOpenByAction: false,
    wasOpenAutomatically: false,
    title: {
      text: '',
      dataMnemonic: '@DATA@',
      default: 'Solicitação de Horas Extras - @DATA@',
    },
    feriado: {
      title: 'Solicitação de horas extras para o feriado - @DATA@',
    },
    timeToOpen: 500,
    setTitle: (isFeriado: boolean) => {
      let title = isFeriado ?
        this.solicitacaoHorasExtras.feriado.title :
        this.solicitacaoHorasExtras.title.text;

      const mnemonic = this.solicitacaoHorasExtras.title.dataMnemonic;
      const date = this.solicitacaoHorasExtras.data.dia;

      title = title.replace(mnemonic, date);
    },
    overrideSaveAction: this.solicitarHorasExtras,
    possuiDiasParaSolicitar: () => {
      return this.solicitacaoHorasExtras.data || this.solicitacaoHorasExtras.datas.length > 0;
    },
    openAutomatically: () => {
      this.solicitacaoHorasExtras.wasOpenAutomatically = true;
      this.solicitacaoHorasExtras.wasOpenByAction = false;
    },
    openByAction: () => {
      this.solicitacaoHorasExtras.wasOpenAutomatically = false;
      this.solicitacaoHorasExtras.wasOpenByAction = true;
    },
  };
  // #endregion

  // #region [ STORE ]
  @Getter('user')
  private user: any;

  @Getter('periodosDemonstrativo')
  private periodosDemonstrativo: Periodo;

  @Getter('periodoDemonstrativoAtual')
  private periodoDemonstrativoAtual: Periodo;

  @Getter('estruturaGerencialAtual')
  private estruturaGerencialAtual: any;

  // #endregion

  // #region [ COMPUTED ]
  private get toolbarDetailsActions() {
    const noRowIsSelected = this.gridSelected.length === 0;
    const naoMostrarCadAutom = !this.user.idrealizacadautom;

    const toolbarDetailsActions = [
      {
        name: 'cadAutoMarc',
        label: 'Cadastro Automático de Marcações',
        onClick: ControleAcessoWrapper.criar(this.cadastroAutomaticoMarcacoes),
        disabled: noRowIsSelected,
        isNotVisible: naoMostrarCadAutom, // Custom property
      },
      {
        name: 'abonarFalta',
        label: 'Abonar Falta',
        onClick: ControleAcessoWrapper.criar(this.inserirSolicitarAbonoFalta),
        disabled: noRowIsSelected,
      },
      {
        name: 'compensarHoras',
        label: 'Compensar Horas',
        onClick: ControleAcessoWrapper.criar(this.compensarHoras),
        disabled: noRowIsSelected,
      },
      {
        name: 'compensarFalta',
        label: 'Compensar Falta',
        onClick: ControleAcessoWrapper.criar(this.compensarFalta),
        disabled: noRowIsSelected,
      },
      {
        name: 'solicitarHorasExtras',
        label: 'Solicitar Horas Extras',
        onClick: ControleAcessoWrapper.criar(this.solicitarHorasExtrasOnClick),
        disabled: noRowIsSelected,
      },
      {
        name: 'trocaHorario',
        label: 'Trocar Horário',
        onClick: ControleAcessoWrapper.atualizar(this.trocarHorarioOnClick),
        disabled: noRowIsSelected,
      },
      {
        name: 'cadAutoOcor',
        label: 'Cadastro Automático de Ocorrências',
        onClick: ControleAcessoWrapper.criar(this.cadastroAutomaticoOcorrencias, ModuloPermissao.MODULO_OCORRENCIAS),
        disabled: noRowIsSelected,
      },
      {
        name: 'cadApuraAutoAdcNoturno',
        label: 'Apuração Automática de Adicional Noturno',
        onClick: ControleAcessoWrapper.criar(this.cadastroApuraAutoAdcNoturno),
        disabled: noRowIsSelected,
      },
      {
        name: 'horasExtrasNoBancoDeHoras',
        label: 'Incluir horas extras como banco de horas',
        onClick: ControleAcessoWrapper.criar(this.horasExtrasNoBancoDeHorasOnClick),
        disabled: noRowIsSelected,
      },
      {
        name: 'bancoDeHorasNasHorasExtras',
        label: 'Incluir horas de banco como hora extras',
        onClick: ControleAcessoWrapper.criar(this.bancoDeHorasNasHorasExtrasOnClick),
        disabled: noRowIsSelected,
      },
    ];

    return toolbarDetailsActions.filter((action) => !action.isNotVisible);
  }

  private get periodoIsSelected(): boolean {
    const isSelected = !Util.isEmptyOrBlank(this.periodoDemonstrativoAtual);

    return isSelected;
  }

  private get vinculoIsSelected(): boolean {
    const isSelected = this.nrVinculo !== -1;

    return isSelected;
  }

  private get vinculoFilters() {
    const filters = {
      NRPERIODOAPURACAO: this.nrPeriodo,
      NRESTRUTURAM: this.nrEstrutura,
      NRORG: this.user.nrorg,
    };

    return filters;
  }

  private get periodosDemonstrativoFilter() {
    return {
      NRORG: this.user.nrorg,
      NRTIPOVINCULOM: this.user.nrtipovinculom,
    };
  }

  // Mensagem a ser exibida no grid caso os filtros
  // não tenham sido selecionados.
  private get gridNoDataText(): string {
    const message = this.filtersAreSelected ?
      undefined :
      'Favor selecionar uma unidade, período e vínculo.';

    return message;
  }

  private get gridUrlParams(): object {
    const urlParams = {
      NRVINCULOM: this.nrVinculo,
      NRPERIODOAPURACAO: this.nrPeriodo,
      NRORG: this.user.nrorg,
    };

    return urlParams;
  }

  private get nrPeriodo(): number {
    const nrPeriodoAPuracao = Util.isEmptyOrBlank(this.periodoDemonstrativoAtual) ?
      undefined :
      parseInt(this.periodoDemonstrativoAtual.NRPERIODOAPURACAO, 10);

    return nrPeriodoAPuracao;
  }

  private get nrEstrutura(): number {
    const nrEstruturaGerencial = Util.isEmptyOrBlank(this.estruturaGerencialAtual) ?
      undefined :
      this.estruturaGerencialAtual.NRESTRUTURAM;

    return nrEstruturaGerencial;
  }

  private get nmEstrutura(): string {
    const nmEstruturaGerencial = Util.isEmptyOrBlank(this.estruturaGerencialAtual) ?
      undefined :
      this.estruturaGerencialAtual.NMESTRUTURA;

    return nmEstruturaGerencial;
  }

  private get filtersAreSelected(): boolean {
    const areSelected =
      this.headerFilterAreSelect &&
      this.vinculoIsSelected;

    return areSelected;
  }

  private get headerFilterAreSelect(): boolean {
    const areSelected =
      this.nrPeriodo !== undefined &&
      this.nrEstrutura !== undefined;

    return areSelected;
  }

  private get vinculoNoDataText(): string {
    const text = this.headerFilterAreSelect ?
      'Nenhum vínculo encontrado.' :
      'Selecione uma unidade e um período.';

    return text;
  }

  private get actionsColumnWidth(): number {
    const width = Math.max(60, (this.customActions.length + 1) * 30);

    return width;
  }

  private get canUserEditCurrentPeriodo() {
    const canUserEditCurrentPeriodo = this.$store.state.canUserEditCurrentPeriodo;

    return canUserEditCurrentPeriodo;
  }

  private get stringSelectedDates(): string[] {
    return this.gridSelected.map((date) => date.DIA);
  }

  private get nrVinculo(): number {
    const nrVinculo = this.vinculo ?
      parseInt(this.vinculo.NRVINCULOM, 10) :
      -1;

    return nrVinculo;
  }

  private get canTrocaHorario() {
    if (this.user.dp) {
      return true;
    }

    const canTrocaHorario = this.user.idtrocahorario === 'S';
    return canTrocaHorario;
  }

  private get actionApurarTodosLabel() {
    return `Apurar Todos os Vínculos da Unidade (${this.vinculos ? this.vinculos.length : '0'})`;
  }

  private get actionRetrocederTodosLabel() {
    return `Retroceder Todos os Vínculos da Unidade (${this.vinculos ? this.vinculos.length : '0'})`;
  }

  private get gridReadonly() {
    return !this.canUserEditCurrentPeriodo || this.user.idbloqueioedicaomarc;
  }
  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    store.commit('changeCurrentView', this.viewName);
    (window as any).demonstrativo = this;
    this.getMotivosOcorrencia();
  }

  private mounted() {
    this.updateGridHeight();

    setInterval(() => {
      if (this.windowLastHeight !== window.innerHeight) {
        this.updateGridHeight();
        this.windowLastHeight = window.innerHeight;
      }
    }, 1000);

    this.periodoOnInput(this.periodoDemonstrativoAtual);
  }
  //#endregion

  // #region [ WATCHERS ]
  @Watch('periodoDemonstrativoAtual')
  private periodoOnInput(selectedPeriodo: Periodo): void {
    this.changeRefreshVisibility(true);
    this.updateToolbarActionsStatus();

    // Timeout para que a computed property possa ser recalculada
    setTimeout(() => {
      this.reloadVinculoSelect();
    });
  }

  @Watch('estruturaGerencialAtual')
  private estruturaGerencialAtualOnChange() {
    this.changeRefreshVisibility(true);
    this.updateToolbarActionsStatus();

    // Timeout para que a computed property possa ser recalculada
    this.reloadVinculoSelect();
  }

  @Watch('ocorPopupControl.showOcorDialog')
  private showOcorDialogOnChange(newValue: boolean) {
    if (!newValue) { // on false
      this.cancelGridSelected();
    }
  }
  // #endregion

  // #region [ METHODS ]
  private reloadData() {
    if (this.filtersAreSelected) {
      this.reloadGrid();
    } else {
      this.reloadVinculoSelect();
    }

  }

  private rowAfterEdit(rowAndColumn: any): void {
    if (rowAndColumn === undefined) {
      return;
    }

    const {row, column} = rowAndColumn;

    row.ENTRADA = Time.formatTime(row.ENTRADA || '00:00');
    row.ALMOCO = Time.formatTime(row.ALMOCO || '00:00');
    row.SAIDA = Time.formatTime(row.SAIDA || '00:00');
    row.HRAUSENCIA = Time.formatTime(row.HRAUSENCIA || '00:00');

    // this.updateFields(row);

    if (column.value === 'DSMOTIVOOCORFREQ') {
      row.IDPROGOCORCONFIRMADA = null;
    }
  }

  private updateFields(row: any): void {
    const tempoJornada = Time.fromString('08:00:00');

    const entrada = Time.fromString(row.ENTRADA);
    const saida = Time.fromString(row.SAIDA);
    const intervalo = Time.fromString(row.ALMOCO);
    const ausencia = Time.fromString(row.HRAUSENCIA);

    row.IDDIA_ENTRADA = MarcacaoUtils.fixDateId(row.IDDIA_ENTRADA);
    row.IDDIA_SAIDA = MarcacaoUtils.fixDateId(row.IDDIA_SAIDA);

    const idDiaEntrada = row.IDDIA_ENTRADA;
    const idDiaSaida = row.IDDIA_SAIDA;

    const fixedEntrada = MarcacaoUtils.fixTimeByDateId(entrada, idDiaEntrada);
    const fixedSaida = MarcacaoUtils.fixTimeByDateId(saida, idDiaSaida);

    const horasTrab = fixedSaida
      .subtract(fixedEntrada)
      .subtract(intervalo)
      .subtract(ausencia);

    const saldoDia = horasTrab.subtract(tempoJornada);

    row.TRABALH = horasTrab.toString('HH:MM');
    row.DIF_TRA = saldoDia.toString('HH:MM');
  }

  private updateFilters(): void {
    const currentVinculoIsInOptions = this.vinculos.reduce((accumulator, vinculo: any) => {
      const isCurrentVinculo =
        parseInt(vinculo.NRVINCULOM, 10) === this.nrVinculo;

      const isInOptions = isCurrentVinculo || accumulator;

      return isInOptions;
    }, false);

    if (!currentVinculoIsInOptions) {
      this.vinculo = null;
    }

    if (this.filtersAreSelected) {
      this.reloadGrid();
    } else {
      this.gridRows = [];
    }
  }

  private gridAfterReload(rows: object[]): void {
    rows.forEach((row: any) => {
      this.setDateDescription(row);
      this.formatTimeFields(row);

      if ((row.ENTRADA && row.ENTRADA !== '-') &&
        (!row.TRABALH || row.TRABALH === '00:00')) {

        // this.updateFields(row);
      }
    });

    this.gridRows = rows;
  }

  private setDateDescription(row: any): void {
    const dayDescription = FormatacaoHora.getDateInReportFormat(row.DIA);

    row.DTAPURACAO = dayDescription;
  }

  private formatTimeFields(row: any): void {
    row.ENTRADA = row.ENTRADA || '-';
    row.SAIDA = row.SAIDA || '-';

    row.HRAUSENCIA = row.HRAUSENCIA
      ? FormatacaoHora.formataHoraDecimal(row.AU_TOTA)
      : '-';

    row.ALMOCO = row.ALMOCO
      ? FormatacaoHora.formataHoraDecimal(row.ALMOCO)
      : '-';

    // 12/05/2021 Condição removida devido a reformatacao dos dados ja formatados
    // if (row.ENTRADA) {
    //   row.HRAUSENCIA = FormatacaoHora.formataHoraDecimal(row.AU_TOTA);
    //   row.ALMOCO = FormatacaoHora.formataHoraDecimal(row.ALMOCO);
    // }

    row.HE_AUTO = parseFloat(row.HE_AUTO) > 0
      ? FormatacaoHora.formataHoraDecimal(row.HE_AUTO)
      : '-';

    row.TRABALH = FormatacaoHora.formataHoraDecimal(row.TRABALH);
    row.DIF_TRA = FormatacaoHora.formataHoraDecimal(row.DIF_TRA);
    row.BH_C_AC = FormatacaoHora.formataHoraDecimal(row.BH_C_AC);
    row.FL_DIAS = FormatacaoHora.formataHoraDecimal(row.FL_DIAS);
    row.IDDSRDESCONTADO = Util.isEmptyOrBlank(row.DSR_DESCONTADO) || row.DSR_DESCONTADO <= 0 ? 'Não' : 'Sim';
    row.DSR_DESCONTADO = FormatacaoHora.formataHoraDecimal(row.DSR_DESCONTADO);
  }

  private changeRefreshVisibility(isVisible: boolean) {
    const refreshItem = 'refresh';
    if (!isVisible) {
      const indexToRemove = this.toolbarNotShowWichDefaultActions.indexOf(refreshItem);
      if (indexToRemove > -1) {
        this.toolbarNotShowWichDefaultActions.splice(indexToRemove, 1);
      }
    } else {
      const refreshItemExists = this.toolbarNotShowWichDefaultActions.find((item) => item === refreshItem);
      if (!refreshItem) {
        this.toolbarNotShowWichDefaultActions.push(refreshItem);
      }
    }
  }

  private vinculoOnInput(selectedVinculo: Vinculo) {
    this.vinculo = selectedVinculo;
    this.updateToolbarActionsStatus();
    this.updateFilters();
  }
  private getBancoHorasStyle(row: any): string {
    const diferencaBancoDeHoras = parseFloat(row.BH_DESC_DIA);

    const style = `color: ${diferencaBancoDeHoras < 0 ? 'blue' : 'black'}`;

    return style;
  }

  private getDiferencaStyle(row: any): string {
    const style = `color: ${this.getTimeColor(row, 'DIF_TRA')}`;

    return style;
  }

  private getMarcStyle(row: any): string{

    if(row.ALERTA_PENDENCIAS_PONTO_DIA == 'alerta'){
      return `mdi mdi-alert-octagram alerta-marcacao`;
    }
    return '';
  }

  private getTimeColor(row: any, columnName: string): string {
    let color: string;


    switch (Time.compare(row[columnName], '00:00')) {
      case 1:
        color = 'green';
        break;
      case -1:
        color = 'red';
        break;
      default:
        color = 'orange';
    }

    return color;
  }

  private updateGridHeight(): void {
    const screenSize = (this as any).$vuetify.breakpoint.name;

    const height = Math.floor(window.innerHeight) - 300;

    this.gridHeight = screenSize !== 'xs' ? height : undefined;
  }

  private async getMotivosOcorrencia(): Promise<any> {
    const params = {
      requestType: 'FilterData',
      NRORG: this.$store.getters.user.nrorg,
      CDOPERADOR: this.$store.getters.user.cdoperador
    };

    const response = await Http.get('getMotivoOcorFreq', params);
    const motivos = response.data.dataset.data;

    const formattedMotivos = motivos.map((motivo: any): any => ({
      text: motivo.DSMOTIVOOCORFREQ,
      value: motivo.NRMOTIVOOCORFREQ,
    }));

    const observationColumn = this.gridCols.find((column: any) => column.value === 'DSMOTIVOOCORFREQ');

    // Atualiza o select de observações
    observationColumn.options = formattedMotivos;
  }

  private getObservacaoStyle(row: any): string {
    const statusObservacao = row.IDPROGOCORCONFIRMADA;

    const relacaoStatus = {
      S: 'green', // Confirmado
      N: 'red', // Rejeitado
      P: 'orange', // Pendente
    };

    const statusColor = relacaoStatus[statusObservacao] || 'black';

    const style = `color: ${statusColor}`;

    return style;
  }

  private reloadVinculoSelect() {
    if (this.nrEstrutura && this.nrPeriodo) {
      this.triggers.reloadVinculoSelect++;
    }
  }

  private vinculoSelectAfterReload(vinculos) {
    this.vinculos = vinculos;
    this.updateActionsLabels();
    this.updateFilters();
  }

  private periodoSelectAfterReload(vinculos: any[]) {
    this.updateFilters();
  }

  private async apurarPeriodo(vinculos: ApuracaoVinculo[], nrPeriodo: number) {
    await ApuracaoController.apurarPeriodo(
      vinculos, this.nrPeriodo
    );

    if (ApuracaoController.hasWarningsLastOperacao()) {
      SnackbarUtils.showMessage('Apuração finalizada. Alertas foram encontrados durante os cálculos.', SnackbarUtils.TYPE_ALERT);
      this.alertasApuracao.show = true;
    } else {
      SnackbarUtils.showMessage('Apuração finalizada com sucesso.');
    }
  }

  private async retrocederPeriodo(vinculos: ApuracaoVinculo[], nrPeriodo: number) {
    await ApuracaoController.retrocederPeriodo(
      vinculos, this.nrPeriodo
    );

    if (ApuracaoController.hasWarningsLastOperacao()) {
      SnackbarUtils.showMessage('Retrocesso finalizado. Alertas foram encontrados durante o processo.', SnackbarUtils.TYPE_ALERT);
      this.alertasApuracao.show = true;
    } else {
      SnackbarUtils.showMessage('Apuração retrocedida com sucesso.');
    }
  }

  private async apurarPeriodoOnClick() {
    const statusPeriodo = await this.verifyStatusPeriodoAndReload();

    if(statusPeriodo == 'FECHADO' && this.periodoDemonstrativoAtual.IDPERIODOAPURACAO != statusPeriodo) {
      await DialogUtils.show(
        'Alerta', 
        'Operação bloqueada! O período se encotra fechado. A página será recarregada para atualizar os dados.',
        null,
        () => window.location.reload(),
        false,
        true
      );
    } else {
      if (!this.vinculo) {
        SnackbarUtils.showMessage('Selecione um vínculo para realizar a apuração', SnackbarUtils.TYPE_ALERT);
        return;
      }

      const vinculosApuracao = [
        { NRVINCULOM: this.vinculo.NRVINCULOM, NMVINCULOM: this.vinculo.NMVINCULOM }
      ];

      await this.apurarPeriodo(vinculosApuracao, this.nrPeriodo);

      this.reloadGrid();
    }
   }

  private async apurarPeriodoTodosOnClick() {
    const statusPeriodo = await this.verifyStatusPeriodoAndReload();

    if(statusPeriodo == 'FECHADO' && this.periodoDemonstrativoAtual.IDPERIODOAPURACAO != statusPeriodo) {
      await DialogUtils.show(
        'Alerta', 
        'Operação bloqueada! O período se encotra fechado. A página será recarregada para atualizar os dados.',
        null,
        () => window.location.reload(),
        false,
        true
      );
    } else {
      const vinculosASeremApurados = this.vinculos.map((vinculo) => { return { NRVINCULOM: vinculo.NRVINCULOM, NMVINCULOM: vinculo.NMVINCULOM }});

      if (vinculosASeremApurados.length < 1) {
        SnackbarUtils.showMessage('Não foram encontrados vínculos na estrutura selecionada para a realização da apuração', SnackbarUtils.TYPE_ALERT);
        return;
      }
      
      await this.apurarPeriodo(vinculosASeremApurados, this.nrPeriodo);

      if (this.filtersAreSelected) {
        this.reloadGrid();
      }
    }
  }

  private async retrocederPeriodoOnClick() {
    const statusPeriodo = await this.verifyStatusPeriodoAndReload();

    if(statusPeriodo == 'FECHADO' && this.periodoDemonstrativoAtual.IDPERIODOAPURACAO != statusPeriodo) {
      await DialogUtils.show(
        'Alerta', 
        'Operação bloqueada! O período se encotra fechado. A página será recarregada para atualizar os dados.',
        null,
        () => window.location.reload(),
        false,
        true
      );
    } else {
      if (!this.vinculo) {
        SnackbarUtils.showMessage('Selecione um vínculo para realizar o retrocesso', SnackbarUtils.TYPE_ALERT);
        return;
      }

      const vinculosApuracao = [
        { NRVINCULOM: this.vinculo.NRVINCULOM, NMVINCULOM: this.vinculo.NMVINCULOM }
      ];

      await this.retrocederPeriodo(vinculosApuracao, this.nrPeriodo);

      this.reloadGrid();
    }
   }

  private async retrocederPeriodoTodosOnClick() {
    const statusPeriodo = await this.verifyStatusPeriodoAndReload();

    if(statusPeriodo == 'FECHADO' && this.periodoDemonstrativoAtual.IDPERIODOAPURACAO != statusPeriodo) {
      await DialogUtils.show(
        'Alerta', 
        'Operação bloqueada! O período se encotra fechado. A página será recarregada para atualizar os dados.',
        null,
        () => window.location.reload(),
        false,
        true
      );
    } else {
      const vinculosASeremRetrocedidos = this.vinculos.map((vinculo) => { return { NRVINCULOM: vinculo.NRVINCULOM, NMVINCULOM: vinculo.NMVINCULOM }});

      if (vinculosASeremRetrocedidos.length < 1) {
        SnackbarUtils.showMessage('Não foram encontrados vínculos na estrutura selecionada para a realização do retrocesso', SnackbarUtils.TYPE_ALERT);
        return;
      }
      
      await this.retrocederPeriodo(vinculosASeremRetrocedidos, this.nrPeriodo);

      if (this.filtersAreSelected) {
        this.reloadGrid();
      }
    }
  }

  private reloadGrid() {
    this.triggers.reloadGrid++;
  }

  // Row pode ser uma row ou um array de rows
  private async openMarcacoesPopup(row: any) {
    const statusPeriodo = await this.verifyStatusPeriodoAndReload();

    if(statusPeriodo == 'FECHADO' && this.periodoDemonstrativoAtual.IDPERIODOAPURACAO != statusPeriodo) {
      await DialogUtils.show(
        'Alerta', 
        'Operação bloqueada! O período se encotra fechado. A página será recarregada para atualizar os dados.',
        null,
        () => window.location.reload(),
        false,
        true
      );
    } else {
      const isMultipleRows = Array.isArray(row);
  
      const dates = isMultipleRows ? row.map((currentRow) => currentRow.DIA) : row.DIA;
  
      this.selectedDates = dates;
  
      this.showMarcacoesPopup = true;
    }

  }

  private async openOcorrenciasPopup(row: any) {
    const statusPeriodo = await this.verifyStatusPeriodoAndReload();

    if(statusPeriodo == 'FECHADO' && this.periodoDemonstrativoAtual.IDPERIODOAPURACAO != statusPeriodo) {
      await DialogUtils.show(
        'Alerta', 
        'Operação bloqueada! O período se encotra fechado. A página será recarregada para atualizar os dados.',
        null,
        () => window.location.reload(),
        false,
        true
      );
    } else {
      this.selectedDate = row.DIA;

      this.showOcorrenciasPopup = true;
      this.triggers.reloadOcorrencias++;
    }
  }

  /**
   * Determines whether the toolbar actions are disabled or not.
   */
  private updateToolbarActionsStatus() {
    // const periodoIsOpen = this.periodoDemonstrativoAtual.IDPERIODOAPURACAO === 'ABERTO';
    const canUserEditCurrentPeriodo = this.canUserEditCurrentPeriodo;
    const cardsAreDisabled = !(this.filtersAreSelected && canUserEditCurrentPeriodo);
    const apuracaoActionsDisabled = !canUserEditCurrentPeriodo || !this.nrEstrutura;

    this.toolbarAdditionalActions.forEach((action: any) => {
      if (this.actionsToShowWithNoFilters.includes(action.name)) {
        action.disabled = apuracaoActionsDisabled;

        const actionsNotToShowWithFiltersNotFilled = action.items.filter((item) => item.customShowOnlyWithFilters);
        actionsNotToShowWithFiltersNotFilled.forEach((action) => action.disabled = !apuracaoActionsDisabled ? !this.filtersAreSelected : apuracaoActionsDisabled);
        return;
      }

      if (this.actionsNotToShowWhenBloqueioEdicao.includes(action.name)) {
        action.disabled = cardsAreDisabled || this.user.idbloqueioedicaomarc;
        return;
      }

      action.disabled = cardsAreDisabled;
    });

    this.toolbarButtonsDisabled = cardsAreDisabled;
  }

  private marcacoesOnClose(show: boolean, changed: boolean) {
    this.showMarcacoesPopup = show;

    if (changed) {
      this.reloadGrid();
      this.gridSelected = [];
    }
  }

  // Permite o cadastro de vários dados de marcação para vários dias de uma vez
  private async cadastroAutomaticoMarcacoes(rowsSelected: any) {
    const statusPeriodo = await this.verifyStatusPeriodoAndReload();

    if(statusPeriodo == 'FECHADO' && this.periodoDemonstrativoAtual.IDPERIODOAPURACAO != statusPeriodo) {
      await DialogUtils.show(
        'Alerta', 
        'Operação bloqueada! O período se encotra fechado. A página será recarregada para atualizar os dados.',
        null,
        () => window.location.reload(),
        false,
        true
      );
    } else {
      const doNotReloadOnOpen = false;
      const isAnyRowSelected = Array.isArray(rowsSelected) && rowsSelected.length > 0;

      const ifSelectedRowHasMarcacoes = this.rowsHaveMarcacoes(rowsSelected);

      if (ifSelectedRowHasMarcacoes) {
        SnackbarUtils.showMessage('Os registros selecionados possuem marcação.', 'error');
        return;
      }

      if (isAnyRowSelected) {
        this.openMarcacoesPopup(rowsSelected);
      }
    }
  }

  private rowHasMarcacoes(row: any): boolean {
    const propertiesIfRowIsEmpty = {
      ENTRADA: this.emptyColumnValue,
      SAIDA: this.emptyColumnValue,
    };

    for (const property in propertiesIfRowIsEmpty) {
      if (row[property] !== propertiesIfRowIsEmpty[property]) {
        return true;
      }
    }

    return false;
  }

  private rowsHaveMarcacoes(rows: any[]): boolean {
    for (const row of rows) {
      const rowHasChanges = this.rowHasMarcacoes(row);
      if (rowHasChanges) {
        return true;
      }
    }

    return false;
  }

  private async downloadMarcacoesFotos(row: any) {
    const route = 'getMarcacoesFotos';

    const params = {
      requestType: 'FilterData',
      NRORG: this.user.nrorg,
      NRVINCULOM: this.nrVinculo,
      DATE: row.DIA,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const files = response.data.dataset.data;

      if (files.length === 0) {
        const message = 'O vínculo não possui nenhuma marcação com foto no dia selecionado.';
        SnackbarUtils.showMessage(message, 'alert', 5000);
      } else {
        this.generateMarcacoesZip(row.DIA, files);
      }
    } catch (err) {
      const message = 'Não foi possível baixar o arquivo.';
      SnackbarUtils.showMessage(message, 'error', 5000);

      throw err;
    }
  }

  private async generateMarcacoesZip(
    date: string,
    marcacaoesFilesData: any[],
  ) {
    const dateUnderline = Util.replaceAll(date, '/', '_');
    const zipName = `marcacoes-${this.nrVinculo}-${dateUnderline}`;

    const marcacoesFiles = marcacaoesFilesData.map((file) => {
      const nrMarcacao = file.NRMARCACAOPONTO;
      const horario = file.HORA_MINUTO;

      const name = `${nrMarcacao}-${horario}`;
      const base64: string = file.base64;
      const type: string = file.type;

      const fileData = {
        name,
        base64,
        type,
      };

      return fileData;
    });

    await FileUtils.createAndDownloadZip(zipName, marcacoesFiles);

    const message = 'Arquivo baixado com sucesso!';
    SnackbarUtils.showMessage(message, 'success', 5000);
  }

  private async salvarMarcacoesGrid(rows: any) {

    try {
      this.validarControleAcesso(rows);
    } catch (error) {
      return;
    }

    // ta chamando o onClick duas vezes, por isso que eu to pondo esse if
    // Corrigir isso

    // emitir evento que rows foram selecionadas pra deixar o botao visivel?
    if (rows) {
      const statusPeriodo = await this.verifyStatusPeriodoAndReload();

      if(statusPeriodo == 'FECHADO' && this.periodoDemonstrativoAtual.IDPERIODOAPURACAO != statusPeriodo) {
        await DialogUtils.show(
          'Alerta', 
          'Operação bloqueada! O período se encotra fechado. A página será recarregada para atualizar os dados.',
          null,
          () => window.location.reload(),
          false,
          true
        );
      } else {
        if (!Array.isArray(rows) || rows.length === 0) {
          SnackbarUtils.showMessage(Messages.NO_ROW_CHANGED, SnackbarUtils.TYPE_ALERT);
          return;
        }

        try {
          const response = await HttpRequest.post('setEntradasSaidasFixos', {
            requestType: 'Row',
            row: {
              NRVINCULOM: this.nrVinculo,
              NRORG: this.$store.getters.user.nrorg,
              CDOPERADOR: this.$store.getters.user.cdoperador,
              ROWS: [...rows],
            },
          });

          if (response.data.messages) {
            let message: string = response.data.messages[0].message;
            message = message.replace('(HCMSERVICES) ', '');

            SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
            return;
          }

          if (response.data.dataset.data.success) {
            SnackbarUtils.showMessage(Messages.MARCACAO_ROWS_SAVED);
            this.reloadData();
            return;
          }

          SnackbarUtils.showMessage(Messages.GENERIC_ERROR, SnackbarUtils.TYPE_ERROR);
        } catch (error) {
          const err = error as any;
          const errorMessage = err.response ? err.response.data.error : Messages.GENERIC_ERROR;
          SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);
        }
      }
    }
  }

  private async inserirSolicitarAbonoFalta() {
    const statusPeriodo = await this.verifyStatusPeriodoAndReload();

    if(statusPeriodo == 'FECHADO' && this.periodoDemonstrativoAtual.IDPERIODOAPURACAO != statusPeriodo) {
      await DialogUtils.show(
        'Alerta', 
        'Operação bloqueada! O período se encotra fechado. A página será recarregada para atualizar os dados.',
        null,
        () => window.location.reload(),
        false,
        true
      );
    } else {
      const rowsAreValid = this.gridSelected.length > 0;

      if (!rowsAreValid) {
        return;
      }

      // abre popup de ocorrencia
      this.ocorPopupControl.showOcorDialog = true;
    }
  }

  private async solicitarAbonoFalta(row: any) {
    const file          = row.FILE          ? row.FILE          : null;
    const observacao    = row.DSOBSERVACAO  ? row.DSOBSERVACAO  : null;
    const cdtabecdi     = row.CDTABECDI     ? row.CDTABECDI     : null;
    const cddiagnost    = row.CDDIAGNOST    ? row.CDDIAGNOST    : null;
    const nrpessoa      = row.NRPESSOA      ? row.NRPESSOA      : null;

    // Confirmation
    await DialogUtils.show('Solicitar Abono de Falta', 'Deseja solicitar o abono de falta?');

    const nrVinculo = this.nrVinculo;
    const dates = this.stringSelectedDates;

    await DemonstrativoController.solicitaAbonoFaltas(
      nrVinculo, dates, observacao, file, true, cdtabecdi, cddiagnost, nrpessoa
    );

    this.ocorPopupControl.showOcorDialog = false;
  }

  private async compensarHoras() {
    const statusPeriodo = await this.verifyStatusPeriodoAndReload();

    if(statusPeriodo == 'FECHADO' && this.periodoDemonstrativoAtual.IDPERIODOAPURACAO != statusPeriodo) {
      await DialogUtils.show(
        'Alerta', 
        'Operação bloqueada! O período se encotra fechado. A página será recarregada para atualizar os dados.',
        null,
        () => window.location.reload(),
        false,
        true
      );
    } else {
      const rowsAreValid = this.verifyOneSelected();

      if (!rowsAreValid) {
        return;
      }

      await DialogUtils.show(
        'Solicitar Compensação de Horas',
        'Deseja solicitar a compensação de horas?',
      );

      const date = this.gridSelected[0].DIA;

      const requestOk = await DemonstrativoController.solicitarCompensacaoHoras(
        this.nrVinculo, date,
      );

      if (requestOk) {
        this.cancelGridSelected();
      }
    }
  }

  private verifyOneSelected(): boolean {
    const valid = this.gridSelected.length === 1;

    if (valid) {
      return true;
    }

    const message = 'Selecione apenas 1 dia!';
    SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ALERT, 5000);

    return false;
  }

  private cancelGridSelected() {
    this.gridSelected = [];
  }

  private async compensarFalta() {
    const statusPeriodo = await this.verifyStatusPeriodoAndReload();

    if(statusPeriodo == 'FECHADO' && this.periodoDemonstrativoAtual.IDPERIODOAPURACAO != statusPeriodo) {
      await DialogUtils.show(
        'Alerta', 
        'Operação bloqueada! O período se encotra fechado. A página será recarregada para atualizar os dados.',
        null,
        () => window.location.reload(),
        false,
        true
      );
    } else {
      const rowsAreValid = this.gridSelected.length > 0;

      if (!rowsAreValid) {
        return;
      }

      await DialogUtils.show(
        'Solicitar Compensação de Falta',
        'Deseja solicitar a compensação de falta?',
      );

      const dates = this.stringSelectedDates;

      DemonstrativoController.solicitaCompensacaoFaltas(
        this.nrVinculo,
        dates,
      );
    }
  }

  private async solicitarHorasExtras(
    row: any,
  ) {
    const statusPeriodo = await this.verifyStatusPeriodoAndReload();

    if(statusPeriodo == 'FECHADO' && this.periodoDemonstrativoAtual.IDPERIODOAPURACAO != statusPeriodo) {
      await DialogUtils.show(
        'Alerta', 
        'Operação bloqueada! O período se encotra fechado. A página será recarregada para atualizar os dados.',
        null,
        () => window.location.reload(),
        false,
        true
      );
    } else {
      const rowsAreValid = this.verifyOneSelected();

      if (!rowsAreValid) {
        return;
      }

      const date: string = this.solicitacaoHorasExtras.data.dia;
      const nrVinculo = this.nrVinculo;
      const observacao: string = row.DSOBSERVACAO;

      const success = await DemonstrativoController.solicitarHorasExtras(
        nrVinculo, date, observacao,
      );

      if (success) {
        this.solicitacaoHorasExtras.show = false;
        this.reloadGrid();
      }
    }
  }

  private openSolicitacaoHorasExtras(datas: Array<{ dia: string, isFeriado: boolean }> = null, useDelay = false) {
    // Se chamada para seguir a fila
    this.solicitacaoHorasExtras.datas = Array.isArray(datas) ?
      datas :
      this.solicitacaoHorasExtras.datas;

    // Atualiza o marcador da data atual
    this.solicitacaoHorasExtras.data  = this.solicitacaoHorasExtras.datas.pop();

    if (this.solicitacaoHorasExtras.data) {
      // Monta texto do PopUp baseado nas propriedades definidas em solicitacaoHorasExtras
      const popUpText = this.solicitacaoHorasExtras.data.isFeriado ?
        this.solicitacaoHorasExtras.feriado.title :
        this.solicitacaoHorasExtras.title.default;

      this.solicitacaoHorasExtras.title.text = popUpText.replace(
        this.solicitacaoHorasExtras.title.dataMnemonic,
        this.solicitacaoHorasExtras.data.dia,
      );

      setTimeout(() => {
        this.solicitacaoHorasExtras.show = true;
      }, (useDelay ? this.solicitacaoHorasExtras.timeToOpen : 0));
    }
  }

  private solicitarHorasExtrasOnClick() {
    const rowsAreValid = this.verifyOneSelected();

    if (!rowsAreValid) {
      return;
    }

    this.solicitacaoHorasExtras.openByAction();

    const dias = this.gridSelected.map((dia) => {
      const diaObj = {
        dia: dia.DIA as string,
        isFeriado: false,
      };

      return diaObj;
    });

    this.openSolicitacaoHorasExtras(dias);
  }

  private async trocarHorarioOnClick() {
    const statusPeriodo = await this.verifyStatusPeriodoAndReload();

    if(statusPeriodo == 'FECHADO' && this.periodoDemonstrativoAtual.IDPERIODOAPURACAO != statusPeriodo) {
      await DialogUtils.show(
        'Alerta', 
        'Operação bloqueada! O período se encotra fechado. A página será recarregada para atualizar os dados.',
        null,
        () => window.location.reload(),
        false,
        true
      );
    } else {
      if (!this.canTrocaHorario) {
        SnackbarUtils.showMessage('Atenção! O operador não possui permissão para trocar horários. Revise as parametrizações cadastradas para a organização', SnackbarUtils.TYPE_ALERT);
        return;
      }

      const rowsAreValid = this.gridSelected.length > 0;

      if (!rowsAreValid) {
        return;
      }

      // abre popup de ocorrencia (troca de horários)
      this.trocaHorarioPopupControl.showOcorDialog = true;
    }
  }

  private async trocarHorario(row, isRowValid) {
    if (!isRowValid) {
      SnackbarUtils.showMessage('Por favor, preencha os campos obrigatórios e tente novamente', SnackbarUtils.TYPE_ALERT);
      return;
    }

    const file          = row.FILE          ? row.FILE          : null;
    const observacao    = row.DSOBSERVACAO  ? row.DSOBSERVACAO  : null;
    const nrHordiam     = row.NRHORDIAM     ? row.NRHORDIAM     : null;

    // Confirmation
    await DialogUtils.show('Inserir troca de horários', 'Deseja realmente realizar a troca dos horários?');

    const nrVinculo = this.nrVinculo;
    const dates = this.stringSelectedDates;

    const success = await DemonstrativoController.setTrocasHorario(
      nrVinculo, dates, observacao, file, nrHordiam
    );

    if (success) {
      this.trocaHorarioPopupControl.showOcorDialog = false;
      this.reloadGrid();
      this.gridSelected = [];
    }

  }

  private getRowClass(row: any): string {
    const rowClass = row.ISDESCANSO === true || row.OCORRENCIA_FERIADO === true ?
      'demonstrativo-descanso' :
      'demonstrativo-trabalho';

    return rowClass;
  }

  private openSituFreqPopup(row: any) {
    this.situFreqPopup.show = true;
    this.situFreqPopup.nrVinculo = this.nrVinculo;
    this.situFreqPopup.date = row.DIA;
  }

  private situFreqPopupOnClose(changed: boolean) {
    if (changed) {
      this.reloadGrid();
    }
  }

  private getDiaColStyle(row: any): string {
    const color = row.ID_COLETOR_PG ? 'blue' : 'black';
    const style = `color: ${color};`;

    return style;
  }

  private updateActionsLabels() {
    this.updateApurarTodosActionsLabels();
    this.updateRetrocederTodosActionsLabels();
  }

  private updateApurarTodosActionsLabels() {
    const actionApurar = this.toolbarAdditionalActions.find((item) => item.name == this.toolbarApurarActionName);
    if (!actionApurar) {
      return;
    }

    const actionApurarTodos = actionApurar.items.find((item) => item.name == this.toolbarApurarTodosActionName);
    actionApurarTodos.label = this.actionApurarTodosLabel;
  }

  private updateRetrocederTodosActionsLabels() {
    const actionRetroceder = this.toolbarAdditionalActions.find((item) => item.name == this.toolbarRetrocederActionName);
    if (!actionRetroceder) {
      return;
    }

    const actionRetrocederTodos = actionRetroceder.items.find((item) => item.name == this.toolbarRetrocederTodosActionName);
    actionRetrocederTodos.label = this.actionRetrocederTodosLabel;
  }

  private openNovaOcorrenciaPopup() {
    this.novaOcorrencia.show = true;
  }

  // Permite o cadastro de vários dados de marcação para vários dias de uma vez
  private async cadastroAutomaticoOcorrencias(rowsSelected: any) {
    const statusPeriodo = await this.verifyStatusPeriodoAndReload();

    if(statusPeriodo == 'FECHADO' && this.periodoDemonstrativoAtual.IDPERIODOAPURACAO != statusPeriodo) {
      await DialogUtils.show(
        'Alerta', 
        'Operação bloqueada! O período se encotra fechado. A página será recarregada para atualizar os dados.',
        null,
        () => window.location.reload(),
        false,
        true
      );
    } else {
      const noLength = Array.isArray(rowsSelected) && !rowsSelected.length;

      if (noLength) {
        SnackbarUtils.showMessage('Você precisa selecionar pelo menos um dia.', 'error');
        return;
      }

      const rows = rowsSelected.map((row: any) => ({ DIA: row.DIA }));

      this.novaOcorrencia.nrVinculo = this.nrVinculo;
      this.novaOcorrencia.rows = rows;
    
      this.openNovaOcorrenciaPopup();
    }
  }


  private openApuraAutoAdcNoturnoPopup() {
    this.apuraAutoAdcNoturno.show = true;
  }

  private async cadastroApuraAutoAdcNoturno(rowsSelected: any) {
    const statusPeriodo = await this.verifyStatusPeriodoAndReload();

    if(statusPeriodo == 'FECHADO' && this.periodoDemonstrativoAtual.IDPERIODOAPURACAO != statusPeriodo) {
      await DialogUtils.show(
        'Alerta', 
        'Operação bloqueada! O período se encotra fechado. A página será recarregada para atualizar os dados.',
        null,
        () => window.location.reload(),
        false,
        true
      );
    } else {
      const noLength = Array.isArray(rowsSelected) && !rowsSelected.length;

      if (noLength) {
        SnackbarUtils.showMessage('Você precisa selecionar pelo menos um dia.', 'error');
        return;
      }

      
      const rows = rowsSelected.map((row: any) => ({ DIA: row.DIA }));


      const diasOrdenados = rows.sort((a, b) => new Date(a.DIA).getTime() - new Date(b.DIA).getTime());
      const diaInicio = diasOrdenados.length > 0 ? diasOrdenados[0].DIA : null;
      const diaFim = diasOrdenados.length > 0 ? diasOrdenados[diasOrdenados.length - 1].DIA : null;

      this.apuraAutoAdcNoturno.nrVinculo = this.nrVinculo;
      this.apuraAutoAdcNoturno.rows = rows;
      this.apuraAutoAdcNoturno.dtiniperiodo = diaInicio;
      this.apuraAutoAdcNoturno.dtfimperiodo = diaFim;
      const nrPeriodo = this.nrPeriodo;
      const vinculosUnidade = this.vinculos.map((vinculo) => { return { NRVINCULOM: vinculo.NRVINCULOM, NMVINCULOM: vinculo.NMVINCULOM }});
      this.apuraAutoAdcNoturno.nrPeriodo = nrPeriodo;
      this.apuraAutoAdcNoturno.vinculosUnidade = vinculosUnidade;
      this.apuraAutoAdcNoturno.nomeUnidade = this.nmEstrutura;
      
    
      this.openApuraAutoAdcNoturnoPopup();
    }
  }

  private async horasExtrasNoBancoDeHorasOnClick() {
    await this.verificarBloqueioPeriodoFechado();

    const rowsAreValid = this.gridSelected.length > 0;

    if (!rowsAreValid) {
      return;
    }

    // abre popup de ocorrencia (Incluir horas extras como banco de horas)
    this.horasExtrasNoBancoDeHorasPopupControl.showOcorDialog = true;
  }

  private async horasExtrasNoBancoDeHoras(row, isRowValid) {
    if (!isRowValid) {
      SnackbarUtils.showMessage('Por favor, preencha os campos obrigatórios e tente novamente', SnackbarUtils.TYPE_ALERT);
      return;
    }

    const file                  = row.FILE              ? row.FILE              : null;
    const observacao            = row.DSOBSERVACAO      ? row.DSOBSERVACAO      : null;
    const qtHoras               = row.QTHORAS           ? row.QTHORAS           : null;
    const nrMotivoOcorFreq      = row.NRMOTIVOOCORFREQ  ? row.NRMOTIVOOCORFREQ  : null;


    // Confirmation
    await DialogUtils.show('Incluir horas extras como banco de horas', 'Deseja realmente incluir horas extras como banco de horas?');

    const nrVinculo = this.nrVinculo;
    const dates = this.stringSelectedDates;

    const success = await DemonstrativoController.setHorasExtrasNoBancoDeHoras(
      nrVinculo, dates, observacao, file, qtHoras, nrMotivoOcorFreq
    );

    if (success) {
      this.horasExtrasNoBancoDeHorasPopupControl.showOcorDialog = false;
      this.reloadGrid();
      this.gridSelected = [];
    }

  }

  private async bancoDeHorasNasHorasExtrasOnClick() {
    await this.verificarBloqueioPeriodoFechado();

    const rowsAreValid = this.gridSelected.length > 0;

    if (!rowsAreValid) {
      return;
    }

    // abre popup de ocorrencia (Incluir horas extras como banco de horas)
    this.bancoDeHorasNasHorasExtrasPopupControl.showOcorDialog = true;
  }

  private async bancoDeHorasNasHorasExtras(row, isRowValid) {
    if (!isRowValid) {
      SnackbarUtils.showMessage('Por favor, preencha os campos obrigatórios e tente novamente', SnackbarUtils.TYPE_ALERT);
      return;
    }

    const file                  = row.FILE              ? row.FILE              : null;
    const observacao            = row.DSOBSERVACAO      ? row.DSOBSERVACAO      : null;
    const qtHoras               = row.QTHORAS           ? row.QTHORAS           : null;
    const nrMotivoOcorFreq      = row.NRMOTIVOOCORFREQ  ? row.NRMOTIVOOCORFREQ  : null;

    // Confirmation
    await DialogUtils.show('Incluir horas de banco como hora extras', 'Deseja realmente incluir horas de banco como hora extras?');

    const nrVinculo = this.nrVinculo;
    const dates = this.stringSelectedDates;

    const success = await DemonstrativoController.setBancoDeHorasNasHorasExtras(
      nrVinculo, dates, observacao, file, qtHoras, nrMotivoOcorFreq
    );

    if (success) {
      this.bancoDeHorasNasHorasExtrasPopupControl.showOcorDialog = false;
      this.reloadGrid();
      this.gridSelected = [];
    }

  }

  private async verificarBloqueioPeriodoFechado(): Promise<void> {
    const statusPeriodo = await this.verifyStatusPeriodoAndReload();
  
    if (statusPeriodo === 'FECHADO' && this.periodoDemonstrativoAtual.IDPERIODOAPURACAO !== statusPeriodo) {
      await DialogUtils.show(
        'Alerta',
        'Operação bloqueada! O período se encontra fechado. A página será recarregada para atualizar os dados.',
        null,
        () => window.location.reload(),
        false,
        true
      );
      
      // Lança um erro para interromper a execução
      throw new Error('Período fechado');
    }
  }
  

  private async verifyStatusPeriodoAndReload() {
    if(!this.user.dp) {
      try {
        const route = 'getPeriodoDemonstrativoUnico';
        const nrorg = store.getters.user.nrorg;
  
        const params = {
          requestType: 'FilterData',
          NRORG: nrorg,
          NRPERIODOAPURACAO: this.nrPeriodo,
        };
        
  
        const response = await HttpRequest.get(route, params, true);
        const periodo = response.data.dataset.data[0];
        const statusPeriodo = periodo.IDPERIODOAPURACAO;
  
        return statusPeriodo;
  
      } catch (err) {
        throw 'Não foi possível encontrar o período atual, favor atualizar a página.';
      }
    }

    return 'ABERTO';
  }  


  private validarControleAcesso(rows: any[]) {
    const rowsAtualizar: any[] = [];
    const rowsCriar: any[] = [];

    for (const row of rows) {
      const originalRow = this.gridRows.find(r => r.DIA === row.DIA);
      if (!originalRow) continue;

      if (
        (!originalRow.ENTRADA || originalRow.ENTRADA == '-') &&
        (!originalRow.SAIDA || originalRow.SAIDA == '-') &&
        (!originalRow.ALMOCO || originalRow.ALMOCO == '-')
      ) {
        rowsCriar.push(row);
        continue;
      }


      rowsAtualizar.push(row);
    }

    if (rowsAtualizar.length) {
      ControleAcessoController.validarPermissao(ActionPermissao.IDATUALIZAR);
    }

    if (rowsCriar.length) {
      ControleAcessoController.validarPermissao(ActionPermissao.IDCRIAR);
    }
  }

  
  // #endregion
}


export default Demonstrativo;
